import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { AuthService } from './auth.service';
import {
    IQcBookingRequest, IQcFilters, IQcInspection, IQcPage, IQcPlanPreview, IQcResultRequest, IQcSummary, InspectionLevel,
} from '../interfaces/garments/qcInspection.interface';

const headers = () => AuthService.getAuthHeader();

export const QcInspectionService = {
    list: async (institutionId: string, filters: IQcFilters, page = 0, size = 20): Promise<IQcPage> => {
        const res = await axios.get(ENDPOINTS.QC_INSPECTION.LIST(institutionId), { headers: headers(), params: { ...filters, page, size } });
        return res.data;
    },

    summary: async (institutionId: string, filters: IQcFilters): Promise<IQcSummary> => {
        const { status: _status, ...rest } = filters;
        const res = await axios.get(ENDPOINTS.QC_INSPECTION.SUMMARY(institutionId), { headers: headers(), params: rest });
        return res.data;
    },

    previewPlan: async (
        institutionId: string, lotSize: number, level?: InspectionLevel, aqlMajor?: number, aqlMinor?: number
    ): Promise<IQcPlanPreview> => {
        const res = await axios.get(ENDPOINTS.QC_INSPECTION.PLAN_PREVIEW(institutionId), {
            headers: headers(), params: { lotSize, level, aqlMajor, aqlMinor },
        });
        return res.data;
    },

    get: async (institutionId: string, id: string): Promise<IQcInspection> => {
        const res = await axios.get(ENDPOINTS.QC_INSPECTION.GET(institutionId, id), { headers: headers() });
        return res.data;
    },

    book: async (institutionId: string, request: IQcBookingRequest): Promise<IQcInspection> => {
        const res = await axios.post(ENDPOINTS.QC_INSPECTION.LIST(institutionId), request, { headers: headers() });
        return res.data;
    },

    updateBooking: async (institutionId: string, id: string, request: IQcBookingRequest): Promise<IQcInspection> => {
        const res = await axios.put(ENDPOINTS.QC_INSPECTION.GET(institutionId, id), request, { headers: headers() });
        return res.data;
    },

    cancel: async (institutionId: string, id: string): Promise<IQcInspection> => {
        const res = await axios.post(ENDPOINTS.QC_INSPECTION.CANCEL(institutionId, id), null, { headers: headers() });
        return res.data;
    },

    recordResult: async (institutionId: string, id: string, request: IQcResultRequest): Promise<IQcInspection> => {
        const res = await axios.post(ENDPOINTS.QC_INSPECTION.RESULT(institutionId, id), request, { headers: headers() });
        return res.data;
    },

    reinspect: async (institutionId: string, id: string, scheduledDate: string, inspectorName?: string): Promise<IQcInspection> => {
        const res = await axios.post(ENDPOINTS.QC_INSPECTION.REINSPECT(institutionId, id), { scheduledDate, inspectorName }, { headers: headers() });
        return res.data;
    },

    downloadPdf: async (institutionId: string, id: string): Promise<Blob> => {
        const res = await axios.get(ENDPOINTS.QC_INSPECTION.PDF(institutionId, id), { headers: headers(), responseType: 'blob' });
        return res.data;
    },
};
